import React, { useState } from "react";
import {
  Elements,
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { upgradePackage } from "@/utils";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
function CheckoutForm({
  setCurrentStep,
  billingCycle,
  setShowSuccessModal,
  updatePlanData,
  setIsModalOpen,
}) {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setMessage(null);
    if (!stripe || !elements) {
      setError("Stripe has not loaded yet.");
      setLoading(false);
      return;
    }
    // Confirm the payment and save the payment method
    const { error: stripeError, setupIntent } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: window.location.href,
      },
      redirect: "if_required",
    });
    if (stripeError) {
      setError(stripeError.message);
      setLoading(false);
      return;
    }
    // { priceId: "price_1Rl90yA4ox7ufUXKXW0ZZeuB", quantity: 1 },
    // { priceId: "price_1Rl8zuA4ox7ufUXKoaR3FiIQ", quantity: 1 },
    // { priceId: "price_1Rg7RJA4ox7ufUXKnf8CP1vv", quantity: 1 },
    // { priceId: "price_1Rg7QFA4ox7ufUXKGHxSfHbl", quantity: 1 }
    const payload = {
      business_id: updatePlanData?.business_id,
      new_price_id: billingCycle?.value?.price_id,
      payment_method_id: setupIntent?.payment_method,
    };
    // After payment method is saved, call addBusiness
    console.log({ setupIntent, updatePlanData });
    try {
      await upgradePackage(payload);
      setCurrentStep(1);
      setIsModalOpen(false);
      setShowSuccessModal(true);
    } catch (err) {
      setError("Failed to add business.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="custom-form">
        <PaymentElement options={{ layout: "tabs" }} />
        {error && <div className="mt-2 error-text">{error}</div>}
        <div className="mt-4 flex flex-col md:flex-row justify-between">
          <button
            className="w-full bg-gray-200 btn sm:w-auto"
            onClick={() => setCurrentStep(2)}
            type="button"
          >
            Back
          </button>
          <button type="submit" className="btn" disabled={loading}>
            {loading
              ? "Processing..."
              : `Pay $${(billingCycle.value?.price).toFixed(2)}`}
          </button>
        </div>
      </form>
    </>
  );
}

const UpdatePayment = ({
  clientSecret,
  setIsModalOpen,
  setCurrentStep,
  billingCycle,
  setShowSuccessModal,
  updatePlanData,
}) => {
  return (
    <div className="flex flex-col p-6 mx-auto bg-white rounded-lg shadow">
      <Elements stripe={stripePromise} options={{ clientSecret }}>
        <CheckoutForm
          setCurrentStep={setCurrentStep}
          billingCycle={billingCycle}
          setShowSuccessModal={setShowSuccessModal}
          updatePlanData={updatePlanData}
          setIsModalOpen={setIsModalOpen}
        />
      </Elements>
    </div>
  );
};

export default UpdatePayment;
